export const domainReg = /^[a-zA-Z0-9$?¡\-_]+\.[a-zA-Z0-9]{2,4}$/;
export const subdomainReg = /^[a-zA-Z0-9@$?¡\-_]+\.[a-zA-Z0-9@$?¡\-_]+\.[a-zA-Z0-9]{2,4}$/;
export const emailReg = /^[_a-z0-9-.]+@[a-z0-9-]+(.[a-z0-9-]+)(.[a-z]{2,3})$/;
export const stringReg = /^[a-zA-Z0-9ñÑáéíóúÁÉÍÓÚ./@?!#$%&=¡¿-]+$/;
export const stringSpaceReg = /^[ a-zA-Z0-9ñÑáéíóúÁÉÍÓÚ./,@?!#$%&=¡¿-]+$/;
export const emojiReg = /(\p{Emoji_Presentation}|\p{Extended_Pictographic})/gu;
